module.exports = __webpack_public_path__ + "img/VA3.8e7b424e.jpeg";